import { _ as _objectWithoutPropertiesLoose, a as _objectSpread2 } from "./auth-service-tools630.js";
import { createComponent } from "./auth-service-tools631.js";
import { createHook } from "./auth-service-tools637.js";
import { useCallback, createElement } from "react";
import { useDisclosureContent } from "./auth-service-tools682.js";
import "react-dom";
import { Portal } from "./auth-service-tools683.js";
import { D as DialogBackdropContext } from "./auth-service-tools687.js";
import { a as DIALOG_BACKDROP_KEYS } from "./auth-service-tools689.js";
var useDialogBackdrop = createHook({
  name: "DialogBackdrop",
  compose: useDisclosureContent,
  keys: DIALOG_BACKDROP_KEYS,
  useOptions: function useOptions(_ref) {
    var _ref$modal = _ref.modal,
        modal = _ref$modal === void 0 ? true : _ref$modal,
        options = _objectWithoutPropertiesLoose(_ref, ["modal"]);

    return _objectSpread2({
      modal
    }, options);
  },
  useProps: function useProps(options, _ref2) {
    var htmlWrapElement = _ref2.wrapElement,
        htmlProps = _objectWithoutPropertiesLoose(_ref2, ["wrapElement"]);

    var wrapElement = useCallback(function (element) {
      if (options.modal) {
        element = /* @__PURE__ */createElement(Portal, null, /* @__PURE__ */createElement(DialogBackdropContext.Provider, {
          value: options.baseId
        }, element));
      }

      if (htmlWrapElement) {
        return htmlWrapElement(element);
      }

      return element;
    }, [options.modal, htmlWrapElement]);
    return _objectSpread2({
      id: void 0,
      "data-dialog-ref": options.baseId,
      wrapElement
    }, htmlProps);
  }
});
var DialogBackdrop = createComponent({
  as: "div",
  memo: true,
  useHook: useDialogBackdrop
});
export { DialogBackdrop, useDialogBackdrop };